import { useRef } from 'react';
import { twMerge } from 'tailwind-merge';
import { formatTextDate } from '@witmetrics/utils/time';
import { isEmpty } from '@witmetrics/utils/misc';
import { useDateFormatPreference } from '@witmetrics/data-store';
import { useToggle } from '@/hooks/useToggle';
import ContentMenu from '@/menus/ContentMenu';
import { CardListItem } from '@/components/List';
import Chip from '@/components/Chip';
import Icon from '@/components/Icon';
import type { BaseItemProps } from '../../types';
import { classes } from './utils';

export interface ListItemProps extends BaseItemProps {}

export default function ListItem({
  overrideIcon,
  variant,
  name,
  tag,
  details,
  updatedAt,
  iconVariant,
  icon,
  onDownload,
  onShare,
  onMove,
  onView,
  onEdit,
  onDelete,
}: ListItemProps) {
  const menuToggleRef = useRef(null);
  const dateFormat = useDateFormatPreference();
  const [isMenuOpen, toggleMenu] = useToggle();

  const handleEdit = () => {
    toggleMenu(false);
    onEdit();
  };

  const handleDelete = () => {
    toggleMenu(false);
    onDelete();
  };

  const renderIcon = () => {
    return overrideIcon ? (
      icon
    ) : (
      <Icon
        className={classes.itemIcon}
        variant={iconVariant}
        size="base"
        icon={icon}
      />
    );
  };

  const isAurora = variant === 'aurora';

  const description = (
    <>
      {updatedAt && formatTextDate(updatedAt, dateFormat)}
      {updatedAt && !isEmpty(details) && ' | '}
      {details}
    </>
  );

  return (
    <CardListItem
      className={isAurora ? classes.auroraRow : undefined}
      renderIcon={renderIcon}
      renderMenu={(open, ref, onClose) => (
        <ContentMenu
          anchorTo={ref}
          open={open}
          onDownload={onDownload}
          onShare={onShare}
          onMove={onMove}
          onView={onView}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onClose={onClose}
        />
      )}>
      {isAurora ? (
        <div className={classes.auroraContent}>
          <div className={classes.auroraText}>
            <button className={classes.auroraTitle} onClick={onView}>
              {name}
            </button>
            <div className={classes.auroraSub}>{description}</div>
          </div>
          {tag && (
            <Chip className={twMerge(classes.auroraTag, classes.auroraPill)}>
              {tag}
            </Chip>
          )}
        </div>
      ) : (
        <>
          <div className={classes.titleWrapper}>
            <button className={classes.title} onClick={onView}>
              {name}
            </button>
            {tag && <Chip className={classes.tag}>{tag}</Chip>}
          </div>
          <div className={classes.description}>{description}</div>
        </>
      )}
    </CardListItem>
  );
}
